module.exports = __webpack_public_path__ + "img/eco.2dcca7c9.png";